import React from 'react'
import { Layout, dialog } from '../../nq-component'
import { useNavigate } from 'react-router-dom'
import NavBar2 from "../NavBar2";
import { signOutUseCase } from '../../usecases/user';
import createPromise from '../../createPromise';
import ConfirmDialog from '../../base/ConfirmDialog';

function NavBar(props) {
  const { collapsed, setCollapse } = React.useContext(Layout.Context)
  const navigate = useNavigate()

  function onClickNavigate() {
    setCollapse(!collapsed)
  }

  function onClickSignOut() {
    const promise = createPromise();
    dialog.fire({
      html: (
        <ConfirmDialog
          title="Confirm"
          message="Are you sure you want to sign out?"
        />
      ),
      onPositiveClick: () => promise.resolve(),
      onNegativeClick: () => promise.reject(),
    });
    promise
      .then(() => signOutUseCase().execute())
      .then(() => navigate('/signin'))
      .catch(() => {});
  }

  return (
    <NavBar2
      className='shadow-sm text-primary'
      title='EBOWR'
      onClickNavigate={onClickNavigate}
      onClickSignOut={onClickSignOut}
      {...props}
    />
  )
}

export default NavBar
